import React, { useContext } from 'react';
import { Icon } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import styles from './PolicyDocumentError.module.scss';
import messages from './PolicyDocumentError.messages';

export default function PolicyDocumentError() {
    const translator = useContext(TranslatorContext);
    return (
        <div>
            <Icon icon="mi-warning" className={styles.exclamationIcon} />
            <span>{translator(messages.unableToAccessDocument)}</span>
        </div>
    );
}
